// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.editUser_dashboard__yUISc {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.editUser_cont2__WDGNX {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.editUser_bodythemelight__KB6by {
  background-color: #f3f6f9;
}

.editUser_bodythemedark__gJc0k {
  background-color: #151521;
}

.editUser_headerthemelight__RcR6X {
  background-color: #fff;
}

.editUser_headerthemedark__1XW9I {
  background-color: #151521;
}

.editUser_menuthemelight__93STk {
  background-color: #fff;
}

.editUser_menuthemedark__yR0K2 {
  background-color: #151521;
}

.editUser_menulinklight__T1Ugp {
  color: #60677e !important;
}

.editUser_menulinklightSelected__LxANp {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.editUser_menulinkdarkSelected__bZWxL {
  color: #fff !important;
  border-radius: 10px;
}

.editUser_menulinkdark__4Mzbh {
  color: #60677e !important;
}

.editUser_menulinklight__T1Ugp:hover {
  color: #1d1d1d !important;
}

.editUser_menulinkdark__4Mzbh:hover {
  color: #fff !important;
}

.editUser_headinglight__iYkug {
  color: #60677e;
}

.editUser_headingdark__CC5Nk {
  color: #60677e;
}

.editUser_searchboxlight__JtJHv {
  background-color: #fff;
  border: none;
}

.editUser_searchboxdark__c8WH1 {
  background-color: #1e1e2d;
  color: #60677e;
}

.editUser_searchboxdark__c8WH1::placeholder {
  color: #60677e;
}

.editUser_tableheadlight__t32QY {
  background-color: #e9eaf0;
}

.editUser_tableheaddark__IU1BY {
  background-color: #1e1e2d;
  color: #60677e;
}

.editUser_tablebodylight__xGR7k {
  background-color: #fff;
}
.editUser_tablebodylight__xGR7k:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.editUser_tablebodydark__ANb75 {
  background-color: #1e1e2d;
  color: #60677e;
}
.editUser_tablebodydark__ANb75:hover {
  background-color: #252530;
  cursor: pointer;
}

.editUser_paginationlight__UynJG {
  color: #60677e !important;
  font-size: 13px !important;
}

.editUser_paginationdark__EfSxZ {
  color: #60677e !important;
  font-size: 13px !important;
}

.editUser_formthemelight__\\+6R3K {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.editUser_formthemedark__91io7 {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.editUser_formthemedark__91io7 ::placeholder {
  color: #60677e;
}

.editUser_viewformlight__y32\\+k {
  background-color: #f3f6f9;
}

.editUser_viewformdark__4VSa4 {
  background-color: #151521;
}

.editUser_permissionboxlight__uvNqc {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.editUser_permissionboxdark__bgl1b {
  background-color: #151521;
  border: none;
}

.editUser_errormsgclr__vFQxR {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.editUser_graphclrlight__0tGaV {
  background-color: #fff;
}

.editUser_graphclrdark__Oe4fN {
  background-color: #1e1e2d;
}

#editUser_card1bglight__kUxQl {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#editUser_card1bgdark__tfYHD {
  background: #392f28;
}

#editUser_card2bglight__ZXiVd {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#editUser_card2bgdark__O1gIJ {
  background: #1c3238;
}

#editUser_card3bglight__xkw1U {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#editUser_card3bgdark__FCvDO {
  background: #3a2434;
}

#editUser_card4bglight__pic05 {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#editUser_card4bgdark__oir3Z {
  background: #2f264f;
}

.editUser_actionbtnlight__3hMAT {
  color: rgba(70, 71, 91, 0.8705882353);
}

.editUser_actionbtndark__c1n4B {
  color: #60677e;
}

.editUser_profiledropdownlight__zqmBO {
  background-color: #fff;
}

.editUser_profiledropdowndark__WK9BI {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .editUser_cont2__WDGNX {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
#editUser_addform__ovjfH {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  margin-top: 20px;
  padding-bottom: 30px;
}
#editUser_addform__ovjfH #editUser_addheading__9mcyJ {
  font-size: 18px;
  font-family: "SFUIDisplay-Medium";
  margin-bottom: 20px;
}
#editUser_addform__ovjfH .editUser_inputbox__iIr1B {
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #ced4da;
  color: #1d1d1d;
  font-size: 14px;
}
#editUser_addform__ovjfH .editUser_inputbox1__XD-nG {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  font-family: "SFUIDisplayRegular";
  color: #60677e;
  font-family: "SFUIDisplayRegular";
}
#editUser_addform__ovjfH .editUser_dateinputbox__jSv61 {
  padding: 7px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#editUser_addform__ovjfH .editUser_dateinputbox1__geCZT {
  padding: 7px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
  font-family: "SFUIDisplayRegular";
}
#editUser_addform__ovjfH .editUser_formlabel__hGsB- {
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-bottom: 0px;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi {
  background-color: #39979d;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw:hover {
  background-color: #39979d;
  color: #fff;
}
#editUser_addform__ovjfH ::placeholder {
  font-size: 14px;
  color: #60677e;
}

@media only screen and (max-width: 600px) {
  #editUser_dashboardcont2__yX3nJ {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/editUser.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AAhQA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAkQJ;AAhQI;EACI,eAAA;EACA,iCDiEQ;EChER,mBAAA;AAkQR;AA/PI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,cD2CM;EC1CN,eAAA;AAiQR;AA/PI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDgCS;EC/BT,iCDgDS;EC/CT,cDkCS;ECjCT,iCD8CS;ACmNjB;AA/PI;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cDyBM;ECxBN,eAAA;AAiQR;AA/PI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDcS;ECbT,cDiBS;EChBT,iCD6BS;ACoOjB;AA/PI;EACI,eAAA;EACA,iCDyBS;ECxBT,kBAAA;AAiQR;AA9PI;EACI,yBDaW;ECZX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAgQR;AA9PQ;EACI,2CDKS;AC2PrB;AA5PI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA8PR;AA5PU;EACE,yBAAA;EACA,WAAA;AA8PZ;AA1PI;EACI,eAAA;EACA,cDtBS;ACkRjB;;AArPE;EACE;IACI,wBDPI;ICQJ,UDPG;ICQH,kBAAA;IACA,aDdW;ECsQjB;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 20px;\n    padding-bottom:30px;\n\n    #addheading{\n        font-size: 18px;\n        font-family: $sffont-medium;\n        margin-bottom: 20px;\n    }\n\n    .inputbox{\n        padding: 10px;\n        border-radius: 5px;\n        width: 100%;\n        border: 1px solid #ced4da;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        font-family: $sffont-regular;\n        color: $lightthemetext;\n        font-family: $sffont-regular;\n    }\n    .dateinputbox{\n        padding: 7px;\n        border: 1px solid #ced4da;\n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        padding: 7px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext;\n        font-family: $sffont-regular;\n    }\n    .formlabel{\n        font-size: 14px;\n        font-family: $sffont-regular;\n        margin-bottom: 0px;\n    }\n    \n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n\n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n\n  }\n  \n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `editUser_dashboard__yUISc`,
	"cont2": `editUser_cont2__WDGNX`,
	"bodythemelight": `editUser_bodythemelight__KB6by`,
	"bodythemedark": `editUser_bodythemedark__gJc0k`,
	"headerthemelight": `editUser_headerthemelight__RcR6X`,
	"headerthemedark": `editUser_headerthemedark__1XW9I`,
	"menuthemelight": `editUser_menuthemelight__93STk`,
	"menuthemedark": `editUser_menuthemedark__yR0K2`,
	"menulinklight": `editUser_menulinklight__T1Ugp`,
	"menulinklightSelected": `editUser_menulinklightSelected__LxANp`,
	"menulinkdarkSelected": `editUser_menulinkdarkSelected__bZWxL`,
	"menulinkdark": `editUser_menulinkdark__4Mzbh`,
	"headinglight": `editUser_headinglight__iYkug`,
	"headingdark": `editUser_headingdark__CC5Nk`,
	"searchboxlight": `editUser_searchboxlight__JtJHv`,
	"searchboxdark": `editUser_searchboxdark__c8WH1`,
	"tableheadlight": `editUser_tableheadlight__t32QY`,
	"tableheaddark": `editUser_tableheaddark__IU1BY`,
	"tablebodylight": `editUser_tablebodylight__xGR7k`,
	"tablebodydark": `editUser_tablebodydark__ANb75`,
	"paginationlight": `editUser_paginationlight__UynJG`,
	"paginationdark": `editUser_paginationdark__EfSxZ`,
	"formthemelight": `editUser_formthemelight__+6R3K`,
	"formthemedark": `editUser_formthemedark__91io7`,
	"viewformlight": `editUser_viewformlight__y32+k`,
	"viewformdark": `editUser_viewformdark__4VSa4`,
	"permissionboxlight": `editUser_permissionboxlight__uvNqc`,
	"permissionboxdark": `editUser_permissionboxdark__bgl1b`,
	"errormsgclr": `editUser_errormsgclr__vFQxR`,
	"graphclrlight": `editUser_graphclrlight__0tGaV`,
	"graphclrdark": `editUser_graphclrdark__Oe4fN`,
	"card1bglight": `editUser_card1bglight__kUxQl`,
	"card1bgdark": `editUser_card1bgdark__tfYHD`,
	"card2bglight": `editUser_card2bglight__ZXiVd`,
	"card2bgdark": `editUser_card2bgdark__O1gIJ`,
	"card3bglight": `editUser_card3bglight__xkw1U`,
	"card3bgdark": `editUser_card3bgdark__FCvDO`,
	"card4bglight": `editUser_card4bglight__pic05`,
	"card4bgdark": `editUser_card4bgdark__oir3Z`,
	"actionbtnlight": `editUser_actionbtnlight__3hMAT`,
	"actionbtndark": `editUser_actionbtndark__c1n4B`,
	"profiledropdownlight": `editUser_profiledropdownlight__zqmBO`,
	"profiledropdowndark": `editUser_profiledropdowndark__WK9BI`,
	"addform": `editUser_addform__ovjfH`,
	"addheading": `editUser_addheading__9mcyJ`,
	"inputbox": `editUser_inputbox__iIr1B`,
	"inputbox1": `editUser_inputbox1__XD-nG`,
	"dateinputbox": `editUser_dateinputbox__jSv61`,
	"dateinputbox1": `editUser_dateinputbox1__geCZT`,
	"formlabel": `editUser_formlabel__hGsB-`,
	"formbtn": `editUser_formbtn__xQSoi`,
	"arrowback": `editUser_arrowback__8QUpw`,
	"dashboardcont2": `editUser_dashboardcont2__yX3nJ`
};
export default ___CSS_LOADER_EXPORT___;
